<template>
  <CustomDeleteDialog
    dialogTitle="حذف یک تخفیف حجمی"
    dialogId="delete-volume-discount-confirmation-dialog"
    okTitle="حذف"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteVolumeDiscountRequest"
  >
    <BCol cols="12" v-if="selectedVolumeDiscount">
      <p>آیا از حذف تخفیف حجمی انتخابی اطمینان دارید؟</p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedVolumeDiscount: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteVolumeDiscountRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAVolumeDiscount = new DeleteAVolumeDiscount(_this);
        deleteAVolumeDiscount.setRequestParam({
          id: _this.selectedVolumeDiscount.id,
        });
        await deleteAVolumeDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تخفیف با موفقیت حذف شد.",
              },
            });
            this.$bvModal.hide("delete-volume-discount-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { DeleteAVolumeDiscount } from "@/libs/Api/VolumeDiscounts";
</script>
